module.exports = __webpack_public_path__ + "static/media/revlum.3e71c46b.png";